<div fxLayout="row" class="background">
  <div fxFlex="80" fxFlexOffset="10%">

    <section id="header">
      <h1 class="h1Header">ADMINISTRAR CADETES</h1>
    </section>

    <mat-card class="mat-elevation-z0">
      <div>
        <button mat-raised-button class="add-btn" (click)="addPerson()">Agregar Nuevo</button>
      </div>
      <table mat-table [dataSource]="allDeliveries">

        <!-- Name Column -->
        <ng-container matColumnDef="nombre">
          <th mat-header-cell *matHeaderCellDef class="table-header"> Nombre </th>
          <td mat-cell *matCellDef="let delivery" class="table-content"> {{delivery.dsName}}</td>
        </ng-container>

        <!-- Tel Column -->
        <ng-container matColumnDef="telefono">
          <th mat-header-cell *matHeaderCellDef class="table-header"> Teléfono</th>
          <td mat-cell *matCellDef="let delivery" class="table-content"> {{delivery.dsPhone}} </td>
        </ng-container>

        <!-- City Column -->
        <ng-container matColumnDef="comision">
          <th mat-header-cell *matHeaderCellDef class="table-header"> Comisión </th>
          <td mat-cell *matCellDef="let delivery" class="table-content"> {{delivery.qtCommission}} </td>
        </ng-container>

        <!-- State Column -->
        <ng-container matColumnDef="estado">
          <th mat-header-cell *matHeaderCellDef class="table-header">Estado</th>
          <td mat-cell *matCellDef="let delivery" class="table-content"
            [style.color]="delivery.isActive ? '#2C57A7' : '#F44336'">{{delivery.isActive
            | estadoComercio}}</td>

        </ng-container>

        <!-- Schedule Column -->
        <ng-container matColumnDef="horario">
          <th mat-header-cell *matHeaderCellDef class="table-header"> Horario </th>
          <td mat-cell *matCellDef="let delivery" class="table-content"> {{delivery.horario}} </td>
        </ng-container>

        <!-- Options Column -->

        <ng-container matColumnDef="opciones">
          <th mat-header-cell *matHeaderCellDef class="table-header">Opción</th>
          <td mat-cell *matCellDef="let delivery" class="table-content">
            <button mat-mini-fab class="edit-btn"
            matTooltip="Editar persona" (click)="editPerson(delivery.cdDelivery)">
              <mat-icon>create</mat-icon>
            </button>
            <button mat-raised-button
              [ngClass]="{'activate-btn': !delivery.isActive, 'deactivate-btn': delivery.isActive}"
              matTooltip="Cambiar estado"
              (click)="changeStatus(delivery.cdDelivery, delivery.isActive)">
              {{delivery.isActive | changePersonStatus}}</button>
          </td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      </table>

      <mat-paginator
        [length]="totalCount"
        [pageIndex]="pageNumber - 1"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        (page)="onPageChange($event)">
      </mat-paginator>
    </mat-card>
  </div>
</div>